import { render } from "./Nationality.vue?vue&type=template&id=39e4d846&scoped=true"
import script from "./Nationality.vue?vue&type=script&lang=js"
export * from "./Nationality.vue?vue&type=script&lang=js"

import "./Nationality.vue?vue&type=style&index=0&id=39e4d846&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e4d846"]])

export default __exports__